<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>This Brisbane writer obtained his master’s degree in Classics from the University of Queensland in 1980 and is an international baccalaureate examiner. Prior to retirement, he wrote and coordinated for External Studies in Roman History for the Brisbane School of Distance Education.</p><br/>
<p style="text-indent: 00em !important;">Colin has had three novels published, <em>Poseidon’s Grotto</em>, <em>The Flux and Logos</em>, each based on Heraclitean and Platonic philosophy in addition to a theological work, <em>The Messianic Apostasy</em>, examining Pauline concepts. He has just completed another theological work, <em>Saul’s Messianic Khrestus</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?99d425f0